import { createApi } from "@reduxjs/toolkit/query/react";
import { defautBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSucessResponse } from "../../../utils/API/responseMiddleware";
import { encryptQueryString, transformRequest } from "../../../utils/API/requestMiddleware";
import { encryptAES } from "../../../services/CryptoService";

const GMPCourseProviderApi = createApi({
    reducerPath: 'GMPCourseProviderApi',
    baseQuery: defautBaseQuery,
    endpoints: (builder) => ({
        getAllGMPCourseProvider: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/GetAllGMPCourseProvider',
                method: 'POST',
                body: transformRequest(details,"create")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        UpdateGmpCourseProvider: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/UpdateGmpCourseProvider',
                method: 'POST',
                body: transformRequest(details,"update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        StaffDecisionApproveOrReject: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/StaffDecisionApproveOrReject',
                method: 'POST',
                body: transformRequest(details,"update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCourseProviderByMemberId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/GMPCourseProvider/GetCourseProviderByMemberId?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCourseProviderCommitteeApprovalList: builder.query({
            query: (GmpCourseProviderId) => ({
                url: encryptQueryString(`/GMPCourseProvider/CourseProviderCommitteeApprovalList?GmpCourseProviderId=${parseInt(GmpCourseProviderId)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        InternalNotesStaffAndCommittee: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/GMPCourseProvider/InternalNotesStaffAndCommittee?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        CommitteDecisionApproveOrReject: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/CommitteDecisionApproveOrReject',
                method: 'POST',
                body: transformRequest(details,"update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCPDEventByCpdEventId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CPDEvent/GetCPDEventByCpdEventId?id=${(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getDropdownForApprovedCPDEvent: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CPDEvent/GetDropdownForApprovedCPDEvent?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        updateCPDEvent: builder.mutation({
            query: (details) => ({
                url: '/CPDEvent/UpdateCPDEvent',
                method: 'POST',
                body: transformRequest(details,"update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getCPDEventCommiteeApprovalList: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CPDEvent/CPDEventCommitteeApprovalList?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        cpdStaffDecisionApproveOrReject: builder.mutation({
            query: (details) => ({
                url: '/CPDEvent/CPDStaffDecisionApproveOrReject',
                method: 'POST',
                body: transformRequest(details,"update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        cPDInternalNotesStaffAndCommittee: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CPDEvent/CPDInternalNotesStaffAndCommittee?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        cPDCommitteDecisionApproveOrReject: builder.mutation({
            query: (details) => ({
                url: '/CPDEvent/CPDCommitteDecisionApproveOrReject',
                method: 'POST',
                body: transformRequest(details,'update')
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllApproveAttendanceSubmission: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/GetAllApproveAttendanceSubmission',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAttendanceListByCpdEvent: builder.mutation({
            query: (details) => ({
                url: '/CPDEvent/GetAttendanceListByCpdEvent',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        saveCPDAttendance: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/SaveCPDAttendance',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllDropdownEventByCourseProviderId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CPDEvent/GetAllDropdownEventByCourseProviderId?id=${parseInt(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addManualAttendanceByCpdEvent: builder.mutation({
            query: (details) => ({
                url: '/CPDEvent/AddManualAttendanceByCpdEvent',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAttendanceByCpdEventId: builder.query({
            query: (id) => ({
                url: encryptQueryString(`/CPDEvent/GetAttendanceByCpdEventId?id=${(id)}`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getManualtAttendanceListByCpdEvent: builder.mutation({
            query: (details) => ({
                url: '/CPDEvent/GetManualtAttendanceListByCpdEvent',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteCpdEventAttendanceById: builder.mutation({
            query: (details) => ({
                url: (`/CPDEvent/DeleteCpdEventAttendanceById?id=${details.id}`),
                method: 'POST',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        approveManualAttendance: builder.mutation({
            query: (details) => ({
                url: '/CPDEvent/ApproveManualAttendance',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        adminComitteeApproveOrRejectForIndividualCourse: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/AdminComitteeApproveOrRejectForIndividualCourse',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getFullNameByGMAPNumber: builder.mutation({
            query: (details) => ({
                url: '/CPDEvent/GetFullNameByGMAPNumber',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getAllApprovedCourseProviderList: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/GetAllApprovedCourseProviderList',
                method: 'POST',
                body: transformRequest(details)
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        } ),
        getOtherRepresentativeList: builder.query( {
            query: ( id ) => ( {
                url: encryptQueryString( `/CPDEvent/GetOtherRepresentativeByCourseProviderId?id=${ parseInt( id ) }` ),
                method: 'GET',
            } ),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        } ),
         resetPasswordOtherRepresentative: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/ResetPasswordForOtherRepresentativeDetailsByAdmin',
                method: 'POST',
                body: transformRequest(details,"update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        } ),
         updateRepresentativeDetails: builder.mutation({
            query: (details) => ({
                url: '/GMPCourseProvider/UpdateOtherRepresentativeDetailsByAdmin',
                method: 'POST',
                body: transformRequest(details,"update")
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
         } ),
        getAttendanceListByCpdEventList: builder.query( {
            query: ( id ) => ( {
                url: encryptQueryString( `/CPDEvent/GetAttendanceListByCpdEventList?id=${ parseInt( id ) }` ),
                method: 'GET',
            } ),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        } ),
    }),
})

export const {
    useGetAllGMPCourseProviderMutation,
    useLazyGetCourseProviderByMemberIdQuery,
    useUpdateGmpCourseProviderMutation,
    useStaffDecisionApproveOrRejectMutation,
    useLazyGetCourseProviderCommitteeApprovalListQuery,
    useLazyInternalNotesStaffAndCommitteeQuery,
    useCommitteDecisionApproveOrRejectMutation,
    useLazyGetCPDEventByCpdEventIdQuery,
    useLazyGetDropdownForApprovedCPDEventQuery,
    useUpdateCPDEventMutation,
    useLazyGetCPDEventCommiteeApprovalListQuery,
    useCpdStaffDecisionApproveOrRejectMutation,
    useLazyCPDInternalNotesStaffAndCommitteeQuery,
    useCPDCommitteDecisionApproveOrRejectMutation,
    useGetAllApproveAttendanceSubmissionMutation,
    useGetAttendanceListByCpdEventMutation,
    useSaveCPDAttendanceMutation,
    useLazyGetAllDropdownEventByCourseProviderIdQuery,
    useAddManualAttendanceByCpdEventMutation,
    useLazyGetAttendanceByCpdEventIdQuery,
    useGetManualtAttendanceListByCpdEventMutation,
    useDeleteCpdEventAttendanceByIdMutation,
    useApproveManualAttendanceMutation,
    useAdminComitteeApproveOrRejectForIndividualCourseMutation,
    useGetFullNameByGMAPNumberMutation,
    useGetAllApprovedCourseProviderListMutation,
    useLazyGetOtherRepresentativeListQuery,
    useResetPasswordOtherRepresentativeMutation,
    useUpdateRepresentativeDetailsMutation,
    useLazyGetAttendanceListByCpdEventListQuery
} = GMPCourseProviderApi;

export default GMPCourseProviderApi;